import ProjectsAdd from "../../main/modules/Projects/pages/ProjectsAdd";
import ProjectsList from "../../main/modules/Projects/pages/ProjectsList";
import ProjectsEdit from "../../main/modules/Projects/pages/ProjectsEdit";
import ProjectTimeReportsTable from "../../main/modules/TimeReports/components/ProjectTimeReportsTable/ProjectTimeReportsTable";
import ProjectTimeReportsForm from "../../main/modules/TimeReports/components/ProjectTimeReportsForm/ProjectTimeReportsForm";
import TimesReportPreview from "../../main/modules/TimeReports/pages/TimesReportPreview";

const projectLayoutRoutes = [
    {
        path: "",
        name: "ProjectsList",
        component: ProjectsList,
        meta: {
            isAuth: true,
            module: "projects",
            subModule: ""
        }
    },
    {
        path: "add",
        name: "ProjectsAdd",
        component: ProjectsAdd,
        meta: {
            isAuth: true,
            module: "projects",
            subModule: ""
        }
    },
    {
        path: "edit",
        name: "ProjectsEdit",
        component: ProjectsEdit,
        meta: {
            isAuth:true,
            module: "projects",
            subModule: ""
        }
    },
    {
        path: "time-reports",
        name: "ProjectTimeReports",
        component: ProjectTimeReportsTable,
        meta: {
            isAuth: true,
            module: "projects",
            subModule: "time-reports"
        }
    },
    {
        path: "time-reports/preview",
        name: "ProjectTimeReportsPreview",
        component: TimesReportPreview,
        meta: {
            isAuth: true,
            module: "projects",
            subModule: "time-reports"
        }
    },
    {
        path: "time-reports/add",
        name: "ProjectTimeForm",
        component: ProjectTimeReportsForm,
        meta: {
            isAuth: true,
            module: "projects",
            subModule: "time-reports"
        }
    }
];

export default projectLayoutRoutes;